function pathFromTo(to) {
    if (typeof to === 'string') {
        return to;
    }
    if (to && typeof to === 'object') {
        return `${to.pathname || ''}${to.search || ''}${to.hash || ''}`;
    }
    return '/';
}

function isSameOriginPath(path) {
    if (path === '') {
        return true;
    }
    if (path.charAt(0) !== '/') {
        return false;
    }

    return path.charAt(1) !== '/' && path.charAt(1) !== '\\';
}

function createFullReloadHistory({ basename } = {}) {
    const prefix = basename || '';
    const toUrl = (to) => {
        const path = pathFromTo(to);
        return isSameOriginPath(path) ? prefix + path : '/';
    };

    return {
        action: 'POP',
        location: {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash,
            state: undefined,
        },
        push: to => window.location.assign(toUrl(to)),
        replace: to => window.location.replace(toUrl(to)),
        createHref: toUrl,
        listen: () => () => {},
        block: () => () => {},
    };
}

export default createFullReloadHistory;
